<div class="container-flex d-flex justify-content-center align-items-center min-vh-100 bg-light">
  <div class="w-100 p-4 bg-white rounded shadow" style="max-width: 400px;">
    @if (showForm) {
      <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
        <div class="form-group mb-3">
          <label for="firstName">First Name</label>
          <input id="firstName" formControlName="firstName" type="text" class="form-control"
            [class.is-invalid]="contactForm.get('firstName')?.invalid && contactForm.get('firstName')?.touched" />
          @if (contactForm.get('firstName')?.invalid && contactForm.get('firstName')?.touched) {
            <div class="invalid-feedback">
              Please fill out all required fields
            </div>
          }
        </div>
        <div class="form-group mb-3">
          <label for="lastName">Last Name</label>
          <input id="lastName" formControlName="lastName" type="text" class="form-control"
            [class.is-invalid]="contactForm.get('lastName')?.invalid && contactForm.get('lastName')?.touched" />
          @if (contactForm.get('lastName')?.invalid && contactForm.get('lastName')?.touched) {
            <div class="invalid-feedback">
              Please fill out all required fields
            </div>
          }
        </div>
        <div class="form-group mb-3">
          <label for="email">Email</label>
          <input id="email" formControlName="email" type="email" class="form-control"
            [class.is-invalid]="contactForm.get('email')?.invalid && contactForm.get('email')?.touched" />
          @if (contactForm.get('email')?.touched && contactForm.get('email')?.errors) {
            <div class="invalid-feedback">
              @if (contactForm.get('email')?.errors?.['required']) {
                <div>Please fill out all required fields</div>
              }
              @if (contactForm.get('email')?.errors?.['email']) {
                <div>Please enter a valid email address</div>
              }
            </div>
          }
        </div>
        <div class="form-group mb-3">
          <label for="subject">Subject</label>
          <input id="subject" formControlName="subject" type="text" class="form-control" maxlength="50"
            [class.is-invalid]="contactForm.get('subject')?.invalid && contactForm.get('subject')?.touched" />
          <div class="invalid-feedback d-block">
            @if (contactForm.get('subject')?.errors?.['required'] && contactForm.get('subject')?.touched) {
              <div>Please fill out all required fields</div>
            }
            @if (contactForm.get('subject')?.errors?.['maxlength'] || contactForm.get('subject')?.value?.length === 50) {
              <div>Maximum 50 characters allowed</div>
            }
          </div>
        </div>
        <div class="form-group mb-3">
          <label for="description">Please provide a detailed description of your query so we can connect you with the right team to help:</label>
          <textarea id="description" formControlName="description" class="form-control" maxlength="4000"
          [class.is-invalid]="contactForm.get('description')?.invalid && contactForm.get('description')?.touched"></textarea>
          <div class="invalid-feedback d-block">
            @if (contactForm.get('description')?.errors?.['required'] && contactForm.get('description')?.touched) {
              <div>Please fill out all required fields</div>
            }
            @if (contactForm.get('description')?.errors?.['maxlength'] || contactForm.get('description')?.value?.length === 4000) {
              <div>Maximum 4000 characters allowed</div>
            }
          </div>
        </div>
        <div class="form-check mb-4">
          <input class="form-check-input" type="checkbox" id="privacyPolicy" formControlName="privacyPolicy" [class.is-invalid]="contactForm.get('privacyPolicy')?.invalid && contactForm.get('privacyPolicy')?.touched" />
          <label class="form-check-label" for="privacyPolicy">
            I agree to the <a [href]="privacyPolicyLink" target="_blank" rel="noopener"><b><u>Privacy Policy</u></b></a>
          </label>
          @if (contactForm.get('privacyPolicy')?.invalid && contactForm.get('privacyPolicy')?.touched) {
            <div class="invalid-feedback">
              You must agree to the Privacy Policy
            </div>
          }
        </div>
        <button type="submit" class="btn btn-primary w-100" [disabled]="contactForm.invalid || submitting">
          @if (!submitting) {
            <span>Submit</span>
          }
          @if (submitting) {
            <span>
              <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Submitting
            </span>
          }
        </button>
      </form>
    }
    @if (showSuccess) {
      <div class="alert alert-success text-center my-4">
        <h4 class="mb-2">Thank you!</h4>
        <p>Your message has been sent successfully.</p>
      </div>
    }
    @if (showError) {
      <div class="alert alert-danger text-center my-4">
        <h4 class="mb-2">Message Not Sent</h4>
        <p>There was a problem sending your message. Please contact us by email:</p>
        <a [href]="'mailto:' + errorEmail">{{ errorEmail }}</a>
      </div>
    }
  </div>
</div>
<router-outlet></router-outlet>